<div class="welcome-wrapper">
  <!-- Hero Section -->
  <div class="bgImgMain">
    <div class="container-fluid">
      <h1>رؤية مصر 2030</h1>
      <p>
        تعتزم رؤية مصر 2030 خلق اقتصاد تنافسي ومتوازن ومتنوع قائم على الابتكار
        والمعرفة والعدالة الاجتماعية والتنمية الاقتصادية والبيئة.
      </p>
    </div>
  </div>

  <!-- Services Section -->
  <section class="eservices container-fluid">
    <div class="home-service-card row align-items-center greenItem">
      
      <!-- Title Column -->
      <div class="col-12 col-lg-3">
        <h2 class="uppercase">الخدمات الالكترونية</h2>
        <a href="/Arabic/eServices/Pages/default.aspx" title="مشاهدة الكل" class="font-xsl">
          كل الخدمات الالكترونية
          <span class="icon-plus"></span>
        </a>
      </div>

      <!-- Carousel Column -->
      <div class="col-12 col-lg-9">
        <ngx-slick-carousel class="service-carousel" #slickModal="slick-carousel" [config]="slideConfig">
          <div ngxSlickItem *ngFor="let service of services" class="carousel__item">
            <a [href]="service.link" [title]="service.title">
              <div class="carousel__caption">
                <img class="item__img" [src]="service.img" [alt]="service.title">
                <p class="font-lg mr-t20 item__desc">{{ service.title }}</p>
              </div>
            </a>
          </div>
        </ngx-slick-carousel>
      </div>

    </div>
  </section>
</div>